import usePendo from 'common/hooks/usePendo';

const PendoController = props => {
  usePendo(props);
  return null;
};

export default PendoController;
